/* unplugin-vue-components disabled */import { render } from "./highlight.vue?vue&type=template&id=7017fa98&scoped=true"
import script from "./highlight.vue?vue&type=script&setup=true&lang=js"
export * from "./highlight.vue?vue&type=script&setup=true&lang=js"

import "./highlight.vue?vue&type=style&index=0&id=7017fa98&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7017fa98"],['__file',"src/controls/highlight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7017fa98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7017fa98', __exports__)) {
    api.reload('7017fa98', __exports__)
  }
  
  module.hot.accept("./highlight.vue?vue&type=template&id=7017fa98&scoped=true", () => {
    api.rerender('7017fa98', render)
  })

}


export default __exports__